module.exports = __webpack_public_path__ + "static/media/app-open-icon.11a416ea.svg";